<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>内部管理</el-breadcrumb-item>
      <el-breadcrumb-item>内部公示信息</el-breadcrumb-item>
      <el-breadcrumb-item>集团董事会决议</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- Tabs -->
    <el-tabs v-model="activeName" type="border-card">
      <!-- 清单列表 strat -->
      <el-tab-pane label="清单列表" name="first">
        <!-- 筛选条件 start -->
        <el-form :inline="true" :model="keywords" ref="keywordsRef" label-width="82px">
          <el-form-item label="">
            <RsljigouInternal :propsjigouid="keywords.jigouid" :propsjigouname="keywords.jigouname" @change="changeRsljigouInternal"></RsljigouInternal>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="clicksearch">查询</el-button>
          </el-form-item>
        </el-form>
        <!-- 筛选条件 end -->
        <!-- 数据列表 start -->
        <el-table :data="dataList" border stripe>
          <el-table-column prop="ShangJigouName" label="公司名称"></el-table-column>
          <el-table-column prop="CurJigouName" label="申请部门"></el-table-column>
          <el-table-column prop="Filename" label="标题"></el-table-column>
          <el-table-column prop="Name1" label="创建者"></el-table-column>
          <el-table-column prop="Createtime" label="创建时间"></el-table-column>
          <el-table-column prop="operation" label="操作" width="200px">
            <template v-slot="scope">
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="clickmodify(scope.row)">修改</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 数据列表 end -->
        <!-- 分页 -->
        <div class="pages">
          <el-pagination
            @current-change="handleCurrentPageChange"
            :page-size="10"
            layout="total, prev, pager, next, jumper"
            :total="dataListnum"
			:current-page.sync="selectedPageNo">
          </el-pagination>
        </div>
      </el-tab-pane>
      <!-- 清单列表 end -->

    <!-- 添加 start -->
    <el-tab-pane label="添加" name="second">
      <el-form :model="addForm" ref="addFormRef" label-width="70px">
        <el-form-item label="标题" class="addAdminForm">
          <el-input v-model="addForm.filename"></el-input>
        </el-form-item>
        <el-form-item label="内容">
          <VueUeditorWrap v-model="addForm.fileinfo" :config="myConfig"></VueUeditorWrap>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="clickadd">添加</el-button>
          <el-button type="info" @click="clickreturn">返回</el-button>
        </el-form-item>
      </el-form>
    </el-tab-pane>
    <!-- 添加 end -->

    <!-- 修改 start -->
    <el-tab-pane label="修改" name="three" v-if="displayEdit">
      <el-form :model="editForm" ref="editFormRef" label-width="70px">
        <el-form-item label="标题" class="addAdminForm">
          <el-input v-model="editForm.filename"></el-input>
        </el-form-item>
        <el-form-item label="内容">
          <VueUeditorWrap v-model="editForm.fileinfo" :config="myConfig"></VueUeditorWrap>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="clicksave">保存</el-button>
          <el-button type="info" @click="clickreturn">返回</el-button>
        </el-form-item>
      </el-form>
    </el-tab-pane>
    <!-- 修改 end -->

  </el-tabs>
  </div>
</template>

<script>
import RsljigouInternal from '@/components/RsljigouInternal.vue'
import VueUeditorWrap from 'vue-ueditor-wrap'
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
    RsljigouInternal,
    VueUeditorWrap
  },
  name: 'MyNeiBuGongShi5',
  data () {
    return {
      activeName: 'first',
      optionsproduct: [],
      addForm: {
        filename: '',
        fileinfo: ''
      },
      editForm: {
        fileid: '0',
        filename: '',
        fileinfo: ''
      },
      timer: '',
      // 查询
      keywords: {
        jigouid: '-1',
        jigouname: ''
      },
      dataList: [],
      dataListnum: 0,
      selectedPageNo: 1,
      displayEdit: false,
      filetype: 12,
      myConfig: {
        // 编辑器不自动被内容撑高
        autoHeightEnabled: false,
        // 初始容器高度
        initialFrameHeight: 500,
        // 初始容器宽度
        initialFrameWidth: '100%',
        // 上传文件接口
        serverUrl: '',
        // UEditor 资源文件的存放路径，如果你使用的是 vue-cli 生成的项目，通常不需要设置该选项，vue-ueditor-wrap 会自动处理常见的情况，如果需要特殊配置，参考下方的常见问题2
        UEDITOR_HOME_URL: '/UEditor/'
      }
    }
  },
  mounted () {
    this.apiGetErp3FileNum()
    this.apiGetErp3FileList()
  },
  methods: {
    changeRsljigouInternal (vid, vname) {
      this.keywords.jigouid = vid
      this.keywords.jigouname = vname
    },
    clickadd () {
      if (!this.addForm.filename) {
        this.$alert('请输入名称', '提示')
        return
      }
      if (!this.addForm.fileinfo) {
        this.$alert('请上传文件', '提示')
        return
      }
      this.apiAddErp3File()
    },
    clickreturn () {
      this.activeName = 'first'
      this.displayEdit = false
    },
    clickmodify (row) {
      this.activeName = 'three'
      this.displayEdit = true

      this.editForm.fileid = row.Id
      this.editForm.filename = row.Filename
      this.editForm.fileinfo = row.Fileinfo
    },
    clicksave () {
      if (!this.editForm.filename) {
        this.$alert('请输入名称', '提示')
        return
      }
      if (!this.editForm.fileinfo) {
        this.$alert('请上传文件', '提示')
      }
      this.apiEditErp3File()
    },
    clicksearch () {
      this.selectedPageNo = 1
      this.apiGetErp3FileNum()
      this.apiGetErp3FileList()
    },
    handleCurrentPageChange (selectedPageNo) {
      this.apiGetErp3FileList()
    },
    apiGetErp3FileNum: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        filetype: that.filetype,
        jigouid: that.keywords.jigouid
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetErp3FileNum, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataListnum = response.data.Num
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiGetErp3FileList: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        pageno: that.selectedPageNo,
        filetype: that.filetype,
        jigouid: that.keywords.jigouid
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetErp3FileList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataList = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiAddErp3File: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        filetype: that.filetype,
        filename: that.addForm.filename,
        fileinfo: that.addForm.fileinfo
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_AddErp3File, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'
            that.apiGetErp3FileNum()
            that.apiGetErp3FileList()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiEditErp3File: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        fileid: that.editForm.fileid,
        filename: that.editForm.filename,
        fileinfo: that.editForm.fileinfo
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_EditErp3File, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'
            that.displayEdit = false
            that.apiGetErp3FileNum()
            that.apiGetErp3FileList()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
.cell span{
    margin-left: 10px;
}
.select2{
    width: 100%;
}

/deep/ .el-dialog__body {
    padding: 20px 20px;
    color: #606266;
    font-size: 14px;
    word-break: break-all;
}
</style>
